import { c as _c } from "react/compiler-runtime";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { BaseLayout } from "@/lib/components/layouts/BaseLayout";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_public/_auth")({
  component: AuthLayoutRoute,
  beforeLoad: async ({
    context
  }) => {
    if (context.auth) {
      throw redirect({
        to: "/"
      });
    }
  }
});
function AuthLayoutRoute() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(BaseLayout, {
      headerMode: "minimal",
      showFooter: false,
      children: /*#__PURE__*/_jsx("div", {
        className: "flex min-h-screen",
        children: /*#__PURE__*/_jsx("div", {
          className: "m-auto",
          children: /*#__PURE__*/_jsx(Outlet, {})
        })
      })
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}